/* eslint-disable @typescript-eslint/indent */
export const getH1Style = (hostedCamp: boolean | undefined): any =>
  hostedCamp
    ? {
        fontSize: '2rem',
      }
    : {};

export const getInputStyle = (hostedCamp: boolean | undefined): any =>
  hostedCamp
    ? {
        marginBottom: '5px',
        padding: '5px 10px',
        fontSize: '0.9rem',
      }
    : {};
export const getSelectStyle = (hostedCamp: boolean | undefined): any =>
  hostedCamp
    ? {
        fontSize: '0.9rem',
      }
    : {};

export const getFormStyle = (hostedCamp: boolean | undefined): any =>
  hostedCamp
    ? {
        margin: '0',
      }
    : {};
